(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iman-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iman-trust-carousel')) {
    customElements.define('iman-trust-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        const track = this.querySelector('[data-trust-track]');
        const slides = [...track.querySelectorAll('a')];
        if (slides.length < 2) return;
        const controls = this.querySelector('[data-trust-controls]');
        const dots = [...controls.querySelectorAll('[data-trust-dot]')];
        const mobile = matchMedia('(max-width: 749px)');
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        const controller = new AbortController();
        const options = { signal: controller.signal };
        const interval = Math.min(10000, Math.max(4000, Number(this.dataset.interval) || 5000));
        let active = 0;
        let paused = this.dataset.autoplay !== 'true';
        let visible = false;
        let hovered = false;
        let timer;
        const markActive = (index) => {
          active = index;
          this.dataset.activeIndex = String(index);
          dots.forEach((dot, current) => dot.setAttribute('aria-pressed', String(current === index)));
          slides.forEach((slide, current) => {
            if (mobile.matches) {
              slide.tabIndex = current === index ? 0 : -1;
              slide.setAttribute('aria-hidden', String(current !== index));
            } else {
              slide.removeAttribute('tabindex');
              slide.removeAttribute('aria-hidden');
            }
          });
        };
        const move = (index, focus = false) => {
          index = (index + slides.length) % slides.length;
          markActive(index);
          track.scrollTo({ left: slides[index].offsetLeft, behavior: reduced.matches || focus ? 'instant' : 'smooth' });
          if (focus) slides[index].focus({ preventScroll: true });
        };
        const update = () => {
          clearInterval(timer);
          const focused = track.contains(document.activeElement);
          const running = mobile.matches && !reduced.matches && !paused && visible && !hovered && !focused && !document.hidden;
          this.dataset.rotating = String(running);
          controls.hidden = !mobile.matches;
          if (running) timer = setInterval(() => move(active + 1), interval);
        };
        const stop = () => { paused = true; update(); };
        const modeChanged = () => {
          track.scrollTo({ left: 0, behavior: 'instant' });
          markActive(0);
          update();
        };
        dots.forEach((dot, index) => dot.addEventListener('click', () => { stop(); move(index); }, options));
        controls.addEventListener('focusin', stop, options);
        track.addEventListener('pointerdown', stop, options);
        track.addEventListener('focusin', stop, options);
        track.addEventListener('keydown', (event) => {
          if (!mobile.matches) return;
          let target;
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'ArrowRight') target = active + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') target = active + (rtl ? 1 : -1);
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = slides.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          stop();
          move(target, true);
        }, options);
        track.addEventListener('scroll', () => {
          if (!mobile.matches) return;
          const closest = slides.reduce((best, slide, index) => Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - track.scrollLeft) ? index : best, 0);
          markActive(closest);
        }, { ...options, passive: true });
        this.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') { hovered = true; update(); } }, options);
        this.addEventListener('pointerleave', () => { hovered = false; update(); }, options);
        mobile.addEventListener('change', modeChanged, options);
        reduced.addEventListener('change', update, options);
        document.addEventListener('visibilitychange', update, options);
        const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; update(); }, { threshold: 0.5 });
        observer.observe(this);
        modeChanged();
        this.cleanup = () => { clearInterval(timer); observer.disconnect(); controller.abort(); this.cleanup = null; };
      }
      disconnectedCallback() { this.cleanup?.(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iman-home-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iman-product-tabs')) {
    customElements.define('iman-product-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const tabs = [...this.querySelectorAll('[data-tab]')];
        const panels = [...this.querySelectorAll('[data-panel]')];
        if (tabs.length < 2 || tabs.length !== panels.length) return;
        const tablist = this.querySelector('[data-tabs]');
        const select = (index, focus = false) => {
          tabs.forEach((tab, current) => {
            const active = current === index;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
            panels[current].hidden = !active;
          });
          if (focus) tabs[index].focus();
        };
        tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          panels[index].setAttribute('role', 'tabpanel');
          panels[index].setAttribute('aria-labelledby', tab.id);
          tab.addEventListener('click', () => select(index));
          tab.addEventListener('keydown', (event) => {
            const rtl = document.documentElement.dir === 'rtl';
            let next;
            if (event.key === 'ArrowRight') next = (index + (rtl ? tabs.length - 1 : 1)) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : tabs.length - 1)) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            select(next, true);
          });
        });
        tablist.setAttribute('role', 'tablist');
        this.dataset.ready = 'true';
        select(0);
        tablist.hidden = false;
        this.addEventListener('shopify:block:select', (event) => {
          const panel = event.target.closest('[data-panel]');
          const index = panels.indexOf(panel);
          if (index >= 0) select(index);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
